// scroll reveal
const io = new IntersectionObserver((entries)=>{
  entries.forEach(e=>{ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
}, {threshold:.15});
document.querySelectorAll('.reveal').forEach(el=>io.observe(el));

// button ripple on click
document.querySelectorAll('.btn, .cta-small').forEach(btn=>{
  btn.addEventListener('click', function(e){
    const r = document.createElement('span');
    r.className = 'ripple';
    const rect = this.getBoundingClientRect();
    const size = Math.max(rect.width, rect.height);
    r.style.width = r.style.height = size + 'px';
    r.style.left = (e.clientX - rect.left - size/2) + 'px';
    r.style.top = (e.clientY - rect.top - size/2) + 'px';
    this.appendChild(r);
    setTimeout(()=>r.remove(), 650);
  });
});

// 3D tilt on brand cards
if(!window.matchMedia('(prefers-reduced-motion: reduce)').matches){
  document.querySelectorAll('.brand-card').forEach(card=>{
    card.addEventListener('mousemove', e=>{
      const r = card.getBoundingClientRect();
      const x = (e.clientX - r.left)/r.width - .5;
      const y = (e.clientY - r.top)/r.height - .5;
      card.style.transform = `perspective(500px) rotateX(${(-y*10).toFixed(2)}deg) rotateY(${(x*10).toFixed(2)}deg) translateY(-4px)`;
    });
    card.addEventListener('mouseleave', ()=>{ card.style.transform = ''; });
  });
}
// configurator — 3D wheel (three.js r128 core only). Everything is procedural:
//  · rim = custom swept surface: rounded superellipse section, thicker on the Alcantara grips
//    (with thumb notches), twill carbon top & bottom cut on an oblique line like the real part;
//  · Alcantara-wrapped airbag with stitched ring and gloss badge; gloss-black spoke frame with
//    wide control housings (3D keys, chrome roller), open lower spoke with badge plate;
//  · instanced 3D stitching, LED channel set into the top carbon, paddles tucked behind;
//  · PBR materials lit by a prefiltered studio environment + one soft shadow-casting key light.
(function(){
  const canvas = document.getElementById('cfg3d');
  const container = document.getElementById('cfg3d-wrap');
  if(!canvas || typeof THREE === 'undefined') return;
  const V3 = THREE.Vector3;

  const renderer = new THREE.WebGLRenderer({canvas, antialias:true, alpha:true});
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  renderer.toneMappingExposure = 1.1;
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  const maxAniso = renderer.capabilities.getMaxAnisotropy();

  const scene = new THREE.Scene();
  const camera = new THREE.PerspectiveCamera(18, 1, 0.1, 100);   // narrow FOV → almost no perspective
  const lin = hex => new THREE.Color(hex).convertSRGBToLinear();

  // ---- studio environment: dark room + softboxes, prefiltered for reflections ----
  (function(){
    const env = new THREE.Scene();
    env.add(new THREE.Mesh(new THREE.BoxGeometry(24,24,24), new THREE.MeshBasicMaterial({color:0x080808, side:THREE.BackSide})));
    function softbox(w,h,x,y,z,intensity){
      const m = new THREE.Mesh(new THREE.PlaneGeometry(w,h),
        new THREE.MeshBasicMaterial({color:new THREE.Color(0xffffff).multiplyScalar(intensity), side:THREE.DoubleSide}));
      m.position.set(x,y,z); m.lookAt(0,0,0); env.add(m);
    }
    softbox(12,1.6, 0,8,5, 3.0);               // overhead strip → white streak along the top of the rim
    softbox(2.2,8, 8,0,5, 1.6);                // right strip
    softbox(2.2,8, -8,0,5, 1.2);               // left strip
    softbox(8,1.2, 0,-7,4, 0.7);               // low bounce
    const pmrem = new THREE.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(env, 0.02).texture;
    pmrem.dispose();
  })();

  // soft key light (casts the only shadows), gentle side light, faint kicker from behind
  const key = new THREE.DirectionalLight(0xffffff, 0.85);
  key.position.set(1.5, 4, 8);
  key.castShadow = true;
  key.shadow.mapSize.set(2048, 2048);
  Object.assign(key.shadow.camera, {left:-2.2, right:2.2, top:2.2, bottom:-2.2, near:1, far:20});
  key.shadow.bias = -0.0004; key.shadow.normalBias = 0.02;
  scene.add(key);
  const side = new THREE.DirectionalLight(0xffffff, 0.3); side.position.set(6,1,3); scene.add(side);
  const kick = new THREE.DirectionalLight(0xffffff, 0.15); kick.position.set(-3,-2,-4); scene.add(kick);
  scene.add(new THREE.HemisphereLight(0x50505a, 0x080808, 0.35));

  const wheelGroup = new THREE.Group();
  scene.add(wheelGroup);

  // ---- texture helpers ----
  function toTex(c, srgb){
    const t = new THREE.CanvasTexture(c);
    t.wrapS = t.wrapT = THREE.RepeatWrapping; t.anisotropy = maxAniso;
    if(srgb) t.encoding = THREE.sRGBEncoding;
    return t;
  }
  function canvasTex(size, draw, srgb){
    const c = document.createElement('canvas'); c.width = c.height = size;
    draw(c.getContext('2d'), size);
    return toTex(c, srgb);
  }
  function texturePair(size, draw){   // colour canvas + data canvas (bump) drawn in one pass
    const a = document.createElement('canvas'), b = document.createElement('canvas');
    a.width = a.height = b.width = b.height = size;
    draw(a.getContext('2d'), b.getContext('2d'), size);
    return [toTex(a, true), toTex(b, false)];
  }
  const shade = (hex, f) => '#' + new THREE.Color(hex).multiplyScalar(f).getHexString();
  const gray = v => `rgb(${v|0},${v|0},${v|0})`;
  const NEUTRAL = '#3a3a3a';
  // coloured carbon keeps a dark fibre look: the tint is darkened, never a flat saturated colour
  const fibreTint = hex => !hex ? NEUTRAL : shade(hex, 0.62);

  // forged carbon: chopped-fibre flakes. Each flake gets its own roughness so the surface sparkles
  // differently as the view angle changes. Flakes are drawn wrapped so the texture tiles.
  function forgedTextures(tint){
    const col = fibreTint(tint);
    return texturePair(1024, (g, r, S)=>{
      g.fillStyle = '#060606'; g.fillRect(0,0,S,S);
      r.fillStyle = gray(90); r.fillRect(0,0,S,S);
      for(let i=0;i<4200;i++){
        const cx = Math.random()*S, cy = Math.random()*S, rad = 6 + Math.random()*20, n = 4 + (Math.random()*3|0);
        const rot = Math.random()*Math.PI, stretch = 1 + Math.random()*1.6, pts = [];
        for(let k=0;k<n;k++){
          const a = k/n*Math.PI*2 + Math.random()*.5, rr = rad*(.55 + Math.random()*.45);
          const px = Math.cos(a)*rr*stretch, py = Math.sin(a)*rr;
          pts.push([px*Math.cos(rot) - py*Math.sin(rot), px*Math.sin(rot) + py*Math.cos(rot)]);
        }
        const lvl = Math.random();
        const f = lvl > .93 ? .9 + Math.random()*.4 : .18 + lvl*lvl*.55;
        // coloured carbon: roughly a third of the flakes stay neutral black, like a real hybrid layup
        g.fillStyle = shade(tint && Math.random() < .35 ? NEUTRAL : col, f);
        r.fillStyle = gray(40 + Math.random()*90);
        g.strokeStyle = 'rgba(0,0,0,.55)'; g.lineWidth = 1.2;
        for(const dx of [-S,0,S]) for(const dy of [-S,0,S]){
          if(cx+dx < -60 || cx+dx > S+60 || cy+dy < -60 || cy+dy > S+60) continue;
          for(const ctx of [g, r]){
            ctx.beginPath(); pts.forEach(([x,y],k)=> k ? ctx.lineTo(cx+dx+x, cy+dy+y) : ctx.moveTo(cx+dx+x, cy+dy+y));
            ctx.closePath(); ctx.fill();
          }
          g.stroke();
        }
      }
    });
  }
  // 2x2 twill (woven carbon) — black only, as on the reference: very fine tows with a silvery sheen.
  // Each tow is shaded round in the colour map and bumped round in the bump map so the weave
  // flips light/dark with the view angle; faint fibre lines along each tow add the silky glint.
  function twillTextures(){
    return texturePair(1024, (g, b, S)=>{
      const n = 32, cs = S/n;
      g.fillStyle = '#020202'; g.fillRect(0,0,S,S);
      b.fillStyle = '#000'; b.fillRect(0,0,S,S);
      for(let j=0;j<n;j++) for(let i=0;i<n;i++){
        const vertical = ((i - j + 64) % 4) < 2, x = i*cs, y = j*cs;
        const grad = ctx => vertical ? ctx.createLinearGradient(x,0,x+cs,0) : ctx.createLinearGradient(0,y,0,y+cs);
        const gc = grad(g);
        gc.addColorStop(0, '#0c0c0c'); gc.addColorStop(.5, vertical ? '#6e6e6e' : '#333333'); gc.addColorStop(1, '#0c0c0c');
        g.fillStyle = gc; g.fillRect(x+.6, y+.6, cs-1.2, cs-1.2);
        g.strokeStyle = 'rgba(255,255,255,.07)'; g.lineWidth = 1; g.beginPath();
        for(let k=3;k<cs-1;k+=3){ if(vertical){ g.moveTo(x+k,y+1); g.lineTo(x+k,y+cs-1); } else { g.moveTo(x+1,y+k); g.lineTo(x+cs-1,y+k); } }
        g.stroke();
        const gb = grad(b);
        gb.addColorStop(0, gray(30)); gb.addColorStop(.5, gray(230)); gb.addColorStop(1, gray(30));
        b.fillStyle = gb; b.fillRect(x+.6, y+.6, cs-1.2, cs-1.2);
      }
    });
  }
  // Alcantara: dark grey with a soft low-frequency nap + fine fibre bump
  const suedeMap = canvasTex(512, (g,S)=>{
    g.fillStyle = '#3a3a3a'; g.fillRect(0,0,S,S);
    for(let i=0;i<260;i++){
      const x = Math.random()*S, y = Math.random()*S, rr = 20 + Math.random()*70;
      const gr = g.createRadialGradient(x,y,0,x,y,rr), light = Math.random() > .5;
      gr.addColorStop(0, light ? 'rgba(255,255,255,.012)' : 'rgba(0,0,0,.03)'); gr.addColorStop(1,'rgba(0,0,0,0)');
      for(const dx of [-S,0,S]) for(const dy of [-S,0,S]){ g.save(); g.translate(dx,dy); g.fillStyle = gr; g.fillRect(x-rr,y-rr,rr*2,rr*2); g.restore(); }
    }
  }, true);
  const suedeBump = canvasTex(512, (g,S)=>{
    g.fillStyle = '#808080'; g.fillRect(0,0,S,S);
    for(let i=0;i<70000;i++){
      const v = Math.random() > .5 ? 255 : 0;
      g.fillStyle = `rgba(${v},${v},${v},${(Math.random()*.35).toFixed(3)})`;
      g.fillRect(Math.random()*S, Math.random()*S, 1.3, 1.3);
    }
  });
  function scaleUV(geo, sx, sy){
    const uv = geo.attributes.uv;
    for(let i=0;i<uv.count;i++) uv.setXY(i, uv.getX(i)*sx, uv.getY(i)*sy);
    uv.needsUpdate = true; return geo;
  }
  const TEX_TWILL = 2.3, TEX_FORGED = 0.6, TEX_SUEDE = 1.2;   // texture repeats per world unit (1 unit ≈ 12cm)

  // ---- materials ----
  const [forgedMap, forgedRough] = forgedTextures(null);
  const [twillMap, twillBump] = twillTextures();
  // forged carbon: per-flake roughness under a smooth clearcoat → flakes flicker with the view angle
  const forgedMat = new THREE.MeshPhysicalMaterial({map:forgedMap, roughnessMap:forgedRough, roughness:1, metalness:0, clearcoat:1, clearcoatRoughness:.03});
  const twillMat = new THREE.MeshPhysicalMaterial({map:twillMap, bumpMap:twillBump, bumpScale:.003, roughness:.28, metalness:0, clearcoat:1, clearcoatRoughness:.03});
  const suedeMat = new THREE.MeshPhysicalMaterial({map:suedeMap, bumpMap:suedeBump, bumpScale:.012, roughness:1, metalness:0});
  if('sheen' in suedeMat) suedeMat.sheen = new THREE.Color(0x1a1a1a);   // soft fabric rim-light where supported
  const plasticMat = new THREE.MeshStandardMaterial({color:lin(0x121212), roughness:.6, metalness:0});
  const pianoMat = new THREE.MeshPhysicalMaterial({color:lin(0x040404), roughness:.15, metalness:0, clearcoat:1, clearcoatRoughness:.03});
  const buttonMat = new THREE.MeshPhysicalMaterial({color:lin(0x0c0c0c), roughness:.35, metalness:0, clearcoat:.6, clearcoatRoughness:.15});
  const chromeMat = new THREE.MeshStandardMaterial({color:lin(0xd8d8d8), roughness:.12, metalness:1});
  const stitchMat = new THREE.MeshStandardMaterial({color:lin(0xe0141f), roughness:.65});
  const markerMat = new THREE.MeshStandardMaterial({color:lin(0xe0141f), roughness:.6, side:THREE.DoubleSide});
  const seamMat = new THREE.MeshStandardMaterial({color:0x000000, roughness:1});
  const carbonMats = [forgedMat, twillMat];

  // =====================================================================================
  // RIM — round outer edge. Section ≈ 0.26 wide on the carbon, ≈ 0.35 on the grips, with thumb
  // notches just above/below the spokes. Carbon/suede boundaries are oblique: the carbon reaches
  // further along the outer edge than along the inner edge.
  // =====================================================================================
  const RX = 1.575, RY = 1.58, N_TOP = 2.0, N_BOT = 2.4;
  const W_CARBON = 0.27, W_GRIP = 0.45, D_CARBON = 0.13, D_GRIP = 0.15, SE = 2.5;
  const T_TOP = 0.163, T_BOT = 0.345;                      // nominal boundaries (fraction of a turn)
  const bTop = th => T_TOP - 0.019*Math.cos(th);          // oblique cut: θ=0 inner edge, θ=π outer edge
  const bBot = th => T_BOT + 0.02*Math.cos(th);
  const Z = new V3(0,0,1);
  const smooth = (e0,e1,x) => { const u = Math.min(1, Math.max(0, (x-e0)/(e1-e0))); return u*u*(3-2*u); };
  const spow = (v,e) => Math.sign(v)*Math.pow(Math.abs(v), e);
  // outline measured on the reference: a true circular arc over the top, near-straight sides below
  // the centre and a flattened bottom with rounded corners → superellipse whose exponent goes from
  // 2 (circle) on the upper half to 2.4 (slightly boxier) on the lower half
  function outerPoint(t){
    const a = t*Math.PI*2, c = Math.cos(a), sn = Math.sin(a);
    const n = N_TOP + (N_BOT - N_TOP)*smooth(-0.05, 0.4, -c);
    return new V3(RX*spow(sn, 2/n), RY*spow(c, 2/n), 0);
  }
  function gripWidth(t){
    let u = ((t % 1) + 1) % 1; if(u > .5) u = 1 - u;
    // grips swell quickly after the carbon and stay full down to the lower carbon; a slight
    // waist right after the top joint gives the thumb rest seen on the reference
    const g = smooth(T_TOP - .005, T_TOP + .06, u) * (1 - smooth(T_BOT - .05, T_BOT + .005, u));
    const waist = Math.exp(-Math.pow((u - (T_TOP + .03))/0.02, 2));
    return {w: W_CARBON + (W_GRIP - W_CARBON)*g - 0.05*waist, g};
  }
  function rimSection(t){
    const o = outerPoint(t), tan = outerPoint(t + .0005).sub(outerPoint(t - .0005)).normalize();
    const inward = new V3(tan.y, -tan.x, 0);             // rim runs clockwise seen from the driver
    const {w, g} = gripWidth(t), a = w/2, b = D_CARBON + (D_GRIP - D_CARBON)*g;
    return {p:o.addScaledVector(inward, a), tan, inward, a, b};
  }
  // θ = 0 inner edge, π/2 face towards the driver, π outer edge, -π/2 back
  function secPoint(sec, th, grow){
    const c = Math.cos(th), s = Math.sin(th), gr = grow || 0;
    return sec.p.clone().addScaledVector(sec.inward, spow(c, 2/SE)*(sec.a + gr)).addScaledVector(Z, spow(s, 2/SE)*(sec.b + gr));
  }
  function secNormal(sec, th){
    const c = Math.cos(th), s = Math.sin(th);
    return sec.inward.clone().multiplyScalar(spow(c, 2 - 2/SE)/sec.a).addScaledVector(Z, spow(s, 2 - 2/SE)/sec.b).normalize();
  }
  const RIM_LEN = 2*Math.PI*1.45;   // ≈ centreline length, used so UVs are continuous across pieces

  // swept rim surface; t0/t1 may be functions of θ (oblique boundaries)
  function rimMesh(t0, t1, mat, rep, opts){
    opts = opts || {};
    const f0 = typeof t0 === 'function' ? t0 : () => t0, f1 = typeof t1 === 'function' ? t1 : () => t1;
    const nU = Math.max(6, Math.ceil(Math.abs(f1(Math.PI/2) - f0(Math.PI/2))*520)), nV = 72;
    const pos = [], nrm = [], uv = [], idx = [];
    const mid = rimSection((f0(Math.PI/2) + f1(Math.PI/2))/2), perim = 2*Math.PI*Math.sqrt((mid.a*mid.a + mid.b*mid.b)/2);
    const vRep = opts.periodic ? Math.max(1, Math.round(perim*rep*8))/8 : perim*rep;   // twill: whole periods around
    for(let i=0;i<=nU;i++){
      for(let j=0;j<=nV;j++){
        const th = -Math.PI/2 + 2*Math.PI*j/nV;           // seam at the back of the rim
        const a = f0(th), b = f1(th), t = a + (b - a)*i/nU;
        const sec = rimSection(t), p = secPoint(sec, th, opts.grow), n = secNormal(sec, th);
        pos.push(p.x, p.y, p.z); nrm.push(n.x, n.y, n.z); uv.push(t*RIM_LEN*rep, j/nV*vRep);
      }
    }
    for(let i=0;i<nU;i++) for(let j=0;j<nV;j++){
      const a = i*(nV+1) + j, b = a + nV + 1;
      idx.push(a, b, a+1, b, b+1, a+1);
    }
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    geo.setAttribute('normal', new THREE.Float32BufferAttribute(nrm, 3));
    geo.setAttribute('uv', new THREE.Float32BufferAttribute(uv, 2));
    geo.setIndex(idx);
    const m = new THREE.Mesh(geo, mat); wheelGroup.add(m); return m;
  }
  const neg = f => th => -f(th), oneMinus = f => th => 1 - f(th);
  // "Type de carbone" option: forged and woven (twill) versions of the top & bottom carbon are both
  // built with their own UV density; only one set is visible at a time
  const rimForged = [], rimTwill = [];
  rimForged.push(rimMesh(neg(bTop), bTop, forgedMat, TEX_FORGED));                    // top carbon
  rimTwill.push(rimMesh(neg(bTop), bTop, twillMat, TEX_TWILL, {periodic:true}));
  rimMesh(bTop, bBot, suedeMat, TEX_SUEDE);                                   // right grip
  rimForged.push(rimMesh(bBot, oneMinus(bBot), forgedMat, TEX_FORGED));               // bottom carbon
  rimTwill.push(rimMesh(bBot, oneMinus(bBot), twillMat, TEX_TWILL, {periodic:true}));
  rimTwill.forEach(m => m.visible = false);
  rimMesh(oneMinus(bBot), oneMinus(bTop), suedeMat, TEX_SUEDE);               // left grip
  const marker = rimMesh(-0.0052, 0.0052, markerMat, 1, {grow:0.004});                      // 12 o'clock leather band

  // hairline grooves along the (oblique) boundaries
  function boundaryPts(f, grow, th0, th1, n){
    const pts = [];
    for(let j=0;j<=n;j++){ const th = th0 + (th1 - th0)*j/n; pts.push(secPoint(rimSection(f(th)), th, grow)); }
    return pts;
  }
  [bTop, bBot, oneMinus(bBot), oneMinus(bTop)].forEach(f=>{
    const pts = boundaryPts(f, 0.001, 0, Math.PI*2, 64); pts.pop();
    wheelGroup.add(new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(pts, true), 128, 0.0045, 5, true), seamMat));
  });

  // ---- 3D stitching: straight running stitch (dash–gap), raised capsules, instanced ----
  const stitchSegs = [];
  function runStitch(pts, dash, gap){
    let carry = 0;
    for(let i=1;i<pts.length;i++){
      const a = pts[i-1], b = pts[i], seg = a.distanceTo(b);
      let s = carry;
      while(s < seg){
        const e = Math.min(seg, s + dash);
        stitchSegs.push([a.clone().lerp(b, s/seg), a.clone().lerp(b, e/seg)]);
        s += dash + gap;
      }
      carry = s - seg;
    }
  }
  const SEAM_TH = 0.8;   // just in from the inner edge, on the driver-facing side; follows the thumb notches
  [[bTop, bBot, 1],[oneMinus(bBot), oneMinus(bTop), 1]].forEach(([f0,f1])=>{
    const t0 = f0(SEAM_TH) + .004, t1 = f1(SEAM_TH) - .004, pts = [];
    for(let i=0;i<=200;i++) pts.push(secPoint(rimSection(t0 + (t1-t0)*i/200), SEAM_TH, 0.003));
    runStitch(pts, 0.022, 0.014);
  });
  // stitch along the driver-facing half of every carbon/suede boundary, on the suede side
  [[bTop, 1],[bBot, -1],[oneMinus(bBot), 1],[oneMinus(bTop), -1]].forEach(([f, dir])=>{
    runStitch(boundaryPts(th => f(th) + dir*0.007, 0.003, 0.25, 2.6, 40), 0.02, 0.014);
  });

  // ---- helpers for flat parts ----
  function roundedRect(w,h,r){
    const s = new THREE.Shape(), x = -w/2, y = -h/2;
    s.moveTo(x+r,y); s.lineTo(x+w-r,y); s.absarc(x+w-r,y+r,r,-Math.PI/2,0,false);
    s.lineTo(x+w,y+h-r); s.absarc(x+w-r,y+h-r,r,0,Math.PI/2,false);
    s.lineTo(x+r,y+h); s.absarc(x+r,y+h-r,r,Math.PI/2,Math.PI,false);
    s.lineTo(x,y+r); s.absarc(x+r,y+r,r,Math.PI,Math.PI*1.5,false);
    return s;
  }
  function extrude(shape, depth, bev, mat, tex, segs){
    const geo = new THREE.ExtrudeGeometry(shape, {depth, bevelEnabled:true, bevelThickness:bev, bevelSize:bev, bevelSegments:segs || 6, curveSegments:64});
    if(tex) scaleUV(geo, tex, tex);
    return new THREE.Mesh(geo, mat);
  }
  function labelTex(draw, size){
    return canvasTex(size || 256, (g,S)=>{ g.clearRect(0,0,S,S); draw(g,S); }, true);
  }

  // =====================================================================================
  // CENTRE
  // =====================================================================================
  const hubGroup = new THREE.Group();
  hubGroup.position.y = -0.02;
  wheelGroup.add(hubGroup);

  // gloss-black spoke frame: wide side housings for the controls + open, tapered lower spoke
  const HUB = 0.58;
  const A_TOP = Math.asin(0.26/HUB), A_BOT = Math.asin(-0.18/HUB), A_SPOKE = -Math.acos(0.36/HUB);
  const frame = new THREE.Shape();
  frame.moveTo(0, HUB);
  frame.absarc(0, 0, HUB, Math.PI/2, A_TOP, true);
  frame.quadraticCurveTo(0.95, 0.22, 1.40, 0.13);
  frame.lineTo(1.40, -0.09);
  frame.quadraticCurveTo(0.95, -0.17, HUB*Math.cos(A_BOT), HUB*Math.sin(A_BOT));
  frame.absarc(0, 0, HUB, A_BOT, A_SPOKE, true);
  frame.quadraticCurveTo(0.33, -0.95, 0.21, -1.39);
  frame.lineTo(-0.21, -1.39);
  frame.quadraticCurveTo(-0.33, -0.95, HUB*Math.cos(Math.PI - A_SPOKE), HUB*Math.sin(Math.PI - A_SPOKE));
  frame.absarc(0, 0, HUB, Math.PI - A_SPOKE, Math.PI - A_BOT, true);
  frame.quadraticCurveTo(-0.95, -0.17, -1.40, -0.09);
  frame.lineTo(-1.40, 0.13);
  frame.quadraticCurveTo(-0.95, 0.22, HUB*Math.cos(Math.PI - A_TOP), HUB*Math.sin(Math.PI - A_TOP));
  frame.absarc(0, 0, HUB, Math.PI - A_TOP, Math.PI/2, true);
  const cut = new THREE.Path();                         // trapezoid opening under the airbag
  cut.moveTo(-0.13,-0.66); cut.lineTo(0.13,-0.66);
  cut.quadraticCurveTo(0.175,-0.66, 0.17,-0.70);
  cut.lineTo(0.115,-0.90); cut.quadraticCurveTo(0.105,-0.93, 0.075,-0.93);
  cut.lineTo(-0.075,-0.93); cut.quadraticCurveTo(-0.105,-0.93, -0.115,-0.90);
  cut.lineTo(-0.17,-0.70); cut.quadraticCurveTo(-0.175,-0.66, -0.13,-0.66);
  frame.holes.push(cut);
  const FRAME_Z = -0.14, FRAME_D = 0.08, FRAME_BEV = 0.03;
  const frameMesh = extrude(frame, FRAME_D, FRAME_BEV, pianoMat, null, 8);
  frameMesh.position.z = FRAME_Z;
  hubGroup.add(frameMesh);
  const FRAME_FRONT = FRAME_Z + FRAME_D + FRAME_BEV;

  // small badge plate below the opening
  const plate = extrude(roundedRect(0.2, 0.06, 0.02), 0.01, 0.006, pianoMat);
  plate.position.set(0, -1.02, FRAME_FRONT - 0.004); hubGroup.add(plate);
  const plateLbl = new THREE.Mesh(new THREE.PlaneGeometry(0.2, 0.2), new THREE.MeshBasicMaterial({transparent:true, depthWrite:false, toneMapped:false,
    map:labelTex((g,S)=>{ g.textBaseline = 'middle'; g.textAlign = 'left'; g.font = 'italic 700 44px Oswald, Arial, sans-serif';
      const w1 = g.measureText('STR').width, w2 = g.measureText('PERF').width, x0 = (S - w1 - w2)/2;
      g.fillStyle = '#cfcfcf'; g.fillText('STR', x0, S/2); g.fillStyle = '#e0141f'; g.fillText('PERF', x0 + w1, S/2); })}));
  plateLbl.position.set(0, -1.02, FRAME_FRONT + 0.0175); hubGroup.add(plateLbl);

  // airbag: large domed cushion wrapped in Alcantara, stitched ring, gloss badge in the middle
  const prof = [[0.60,-0.12],[0.60,0],[0.592,0.04],[0.56,0.08],[0.48,0.113],[0.36,0.133],[0.22,0.142],[0,0.145]]
    .map(p => new THREE.Vector2(p[0], p[1]));           // bottom→top so normals face out
  const AIR_Z = -0.02;
  const airGeo = new THREE.LatheGeometry(prof, 144);
  { // planar UVs (seen from the driver) so the suede grain doesn't pinch towards the centre
    const p = airGeo.attributes.position, uv = airGeo.attributes.uv;
    for(let i=0;i<p.count;i++) uv.setXY(i, p.getX(i)*TEX_SUEDE, p.getZ(i)*TEX_SUEDE);
    uv.needsUpdate = true;
  }
  const airbag = new THREE.Mesh(airGeo, suedeMat);
  airbag.rotation.x = Math.PI/2; airbag.position.z = AIR_Z;
  hubGroup.add(airbag);
  const domeZ = r => { for(let i=1;i<prof.length;i++){ const a = prof[i-1], b = prof[i];
    if(r <= a.x && r >= b.x) return AIR_Z + a.y + (b.y - a.y)*(a.x - r)/(a.x - b.x); } return AIR_Z + .145; };
  { // stitched ring on the airbag
    const pts = [], R_ST = 0.45;
    for(let i=0;i<=160;i++){ const a = i/160*Math.PI*2; pts.push(new V3(Math.cos(a)*R_ST, Math.sin(a)*R_ST + hubGroup.position.y, domeZ(R_ST) + 0.003)); }   // stitches live in wheel space
    runStitch(pts, 0.022, 0.014);
  }
  const badge = new THREE.Mesh(new THREE.CylinderGeometry(0.21, 0.215, 0.03, 96), pianoMat);
  badge.rotation.x = Math.PI/2; badge.position.z = domeZ(0.21) + 0.005;
  hubGroup.add(badge);
  const badgeRing = new THREE.Mesh(new THREE.TorusGeometry(0.213, 0.006, 10, 128), chromeMat);
  badgeRing.position.z = badge.position.z + 0.015; hubGroup.add(badgeRing);
  const badgeTex = canvasTex(512, (g,S)=>{
    g.clearRect(0,0,S,S); g.textBaseline = 'middle';
    g.font = 'italic 700 104px Oswald, Arial, sans-serif'; g.textAlign = 'left';
    const w1 = g.measureText('STR').width, w2 = g.measureText('PERF').width, x0 = (S - w1 - w2)/2;
    g.fillStyle = '#dcdcdc'; g.fillText('STR', x0, S/2);
    g.fillStyle = '#e0141f'; g.fillText('PERF', x0 + w1, S/2);
  }, true);
  const badgeLbl = new THREE.Mesh(new THREE.PlaneGeometry(0.36,0.36), new THREE.MeshBasicMaterial({map:badgeTex, transparent:true, depthWrite:false, toneMapped:false}));
  badgeLbl.position.z = badge.position.z + 0.0155; hubGroup.add(badgeLbl);
  // discreet "AIRBAG" mark pressed into the suede
  const airLbl = new THREE.Mesh(new THREE.PlaneGeometry(0.2, 0.05), new THREE.MeshBasicMaterial({transparent:true, depthWrite:false, opacity:.5,
    map:labelTex((g,S)=>{ g.fillStyle = '#0b0b0b'; g.font = '600 48px Georgia, serif'; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText('AIRBAG', S/2, S/2); })}));
  airLbl.scale.y = 4; airLbl.position.set(0, -0.36, domeZ(0.36) + 0.002); hubGroup.add(airLbl);

  // control housings, after the reference: tall next to the airbag, top edge dropping towards the
  // grip, rounded outer end. A raised gloss-black bezel surrounds a recessed satin key face carrying
  // 5 raised keys and a chrome roller; left/right mirrored with their own markings.
  function housingShape(s, inset){
    const xi = -s*(0.33 - inset), xo = s*(0.33 - inset);
    const ti = 0.25 - inset, to = 0.12 - inset, bi = -0.26 + inset, bo = -0.19 + inset;
    const r = Math.max(0.03, 0.09 - inset), sh = new THREE.Shape();
    sh.moveTo(xi, ti - r);
    sh.quadraticCurveTo(xi, ti, xi + s*r, ti - 0.02);
    sh.quadraticCurveTo(s*0.02, (ti + to)/2 + 0.035, xo - s*r*1.2, to);         // gently convex top edge
    sh.quadraticCurveTo(xo + s*0.02, to - 0.005, xo + s*0.015, (to + bo)/2);    // rounded outer end
    sh.quadraticCurveTo(xo + s*0.01, bo, xo - s*r*1.2, bo - 0.005);
    sh.lineTo(xi + s*r, bi + 0.01);
    sh.quadraticCurveTo(xi, bi, xi, bi + r);
    sh.lineTo(xi, ti - r);
    return sh;
  }
  const faceMat = new THREE.MeshPhysicalMaterial({color:lin(0x0d0d0d), roughness:.45, metalness:0, clearcoat:.4, clearcoatRoughness:.3});
  [-1,1].forEach(s=>{
    const pod = new THREE.Group();
    pod.position.set(s*0.90, 0.065, FRAME_FRONT - 0.012);
    hubGroup.add(pod);
    pod.add(extrude(housingShape(s, 0), 0.03, 0.014, pianoMat));                  // bezel
    const face = extrude(housingShape(s, 0.035), 0.02, 0.006, faceMat);            // recessed key face
    face.position.z = 0.014; pod.add(face);
    const FZ = 0.04;                                                              // face front
    const keyGeo = new THREE.ExtrudeGeometry(roundedRect(0.15, 0.085, 0.025), {depth:0.007, bevelEnabled:true, bevelThickness:0.004, bevelSize:0.004, bevelSegments:3, curveSegments:20});
    const xo = s*0.105, xi = -s*0.095, rows = [0.075, -0.03, -0.14];
    // [x, y, label]
    const keys = s < 0
      ? [[xo, rows[0], '⊙'], [xi, rows[0], '↺'], [xo + s*0.02, rows[1], 'RES\nCNCL'], [xo, rows[2], '−'], [xi, rows[2], 'LIM']]
      : [[xo, rows[0], '+'], [xi, rows[0], '−'], [xo + s*0.02, rows[1], 'MODE'], [xo, rows[2], '🎙'], [xi, rows[2], '☎']];
    keys.forEach(([x,y])=>{
      const k = new THREE.Mesh(keyGeo, buttonMat);
      k.position.set(x, y, FZ); pod.add(k);
    });
    // chrome roller in a dark slot, towards the airbag side of the middle row
    const rx = -s*0.07, ry = rows[1];
    const slot = extrude(roundedRect(0.12, 0.075, 0.02), 0.008, 0.004, pianoMat);
    slot.position.set(rx, ry, FZ); pod.add(slot);
    const rollerFrame = new THREE.Mesh(new THREE.BoxGeometry(0.1, 0.012, 0.012), chromeMat);
    [ry + 0.03, ry - 0.03].forEach(y=>{ const b = rollerFrame.clone(); b.position.set(rx, y, FZ + 0.014); pod.add(b); });
    const roller = new THREE.Mesh(new THREE.CylinderGeometry(0.022, 0.022, 0.07, 32), chromeMat);
    roller.rotation.z = Math.PI/2; roller.position.set(rx, ry, FZ + 0.012); pod.add(roller);
    for(let i=0;i<10;i++){   // knurling
      const r = new THREE.Mesh(new THREE.TorusGeometry(0.023, 0.0018, 6, 24), pianoMat);
      r.rotation.y = Math.PI/2; r.position.set(rx - 0.032 + i*0.0071, ry, FZ + 0.012); pod.add(r);
    }
    // chrome strip along the lower edge of the bezel
    const strip = new THREE.Mesh(new THREE.BoxGeometry(0.5, 0.008, 0.008), chromeMat);
    strip.position.set(-s*0.02, -0.232, 0.046); strip.rotation.z = s*Math.atan2(0.07, 0.66); pod.add(strip);
    // key markings
    const W = 0.7;
    const ico = new THREE.Mesh(new THREE.PlaneGeometry(W, W), new THREE.MeshBasicMaterial({transparent:true, depthWrite:false, opacity:.85,
      map:labelTex((g,S)=>{
        g.fillStyle = '#e8e8e8'; g.textAlign = 'center'; g.textBaseline = 'middle';
        keys.forEach(([x,y,L])=>{
          const lines = L.split('\n'), big = L.length <= 2;
          g.font = (big ? '600 34px ' : '600 19px ') + 'Inter, Arial, sans-serif';
          lines.forEach((ln,i)=> g.fillText(ln, S/2 + x/W*S, S/2 - y/W*S + (i - (lines.length-1)/2)*20));
        });
      }, 512)}));
    ico.position.z = FZ + 0.0125; pod.add(ico);
  });

  // back of the wheel: rear shell closing the hub (visible when orbiting)
  const shell = new THREE.Mesh(new THREE.SphereGeometry(0.6, 48, 24, 0, Math.PI*2, Math.PI/2, Math.PI/2), plasticMat);
  shell.rotation.x = Math.PI/2; shell.scale.set(1, 0.45, 1); shell.position.z = -0.16;
  hubGroup.add(shell);

  // ---- shift paddles (Automatique only): long twill blades behind the housings, clearly visible
  // above and below them from the front, bent towards the driver, with real thickness ----
  const paddles = [];
  [-1,1].forEach(s=>{
    const sh = new THREE.Shape();
    sh.moveTo(s*0.86, 0.50);
    sh.quadraticCurveTo(s*0.945, 0.63, s*1.03, 0.54);
    sh.quadraticCurveTo(s*1.05, 0.04, s*0.955, -0.44);
    sh.quadraticCurveTo(s*0.885, -0.52, s*0.815, -0.44);
    sh.quadraticCurveTo(s*0.91, 0.04, s*0.86, 0.50);
    const p = extrude(sh, 0.028, 0.012, twillMat, null, 4);
    const pa = p.geometry.attributes.position;
    for(let i=0;i<pa.count;i++) pa.setZ(i, pa.getZ(i) + 0.12*Math.pow(pa.getY(i) - 0.04, 2));   // curve
    pa.needsUpdate = true; p.geometry.computeVertexNormals();
    scaleUV(p.geometry, TEX_TWILL, TEX_TWILL);
    p.position.z = -0.26;
    wheelGroup.add(p); paddles.push(p);
    const mount = new THREE.Mesh(new THREE.BoxGeometry(0.5,0.1,0.05), plasticMat);
    mount.position.set(s*0.6, -0.04, -0.23);
    wheelGroup.add(mount); paddles.push(mount);
    const mark = new THREE.Mesh(new THREE.PlaneGeometry(0.075,0.075), new THREE.MeshBasicMaterial({transparent:true, depthWrite:false, opacity:.85,
      map:labelTex((g,S)=>{ g.fillStyle = '#eeeeee'; g.font = '700 200px Arial, sans-serif'; g.textAlign = 'center'; g.textBaseline = 'middle'; g.fillText(s > 0 ? '+' : '−', S/2, S/2 + 8); })}));
    mark.position.set(s*0.945, 0.45, -0.26 + 0.028 + 0.013 + 0.12*Math.pow(0.45 - 0.04, 2));
    wheelGroup.add(mark); paddles.push(mark);
  });

  // ---- LED module (Avec LED only), after the reference: a gloss-black insert set into the inner
  // half of the top carbon, carrying two shift-light bars (green → yellow → red towards the centre),
  // a small digital display at 12 o'clock and a small button at each end ----
  const ledGroup = new THREE.Group();
  const LM_T = 0.125, LM_TH0 = 0.28, LM_TH1 = 1.72, LM_TH = 1.0, LM_GROW = 0.006;
  // curved patch of the rim surface (t0..t1 along the rim, th0..th1 around the section)
  function rimPatch(t0, t1, th0, th1, grow, mat){
    const nU = 140, nV = 20, pos = [], nrm = [], idx = [];
    for(let i=0;i<=nU;i++){
      const sec = rimSection(t0 + (t1 - t0)*i/nU);
      for(let j=0;j<=nV;j++){
        const th = th0 + (th1 - th0)*j/nV, p = secPoint(sec, th, grow), n = secNormal(sec, th);
        pos.push(p.x, p.y, p.z); nrm.push(n.x, n.y, n.z);
      }
    }
    for(let i=0;i<nU;i++) for(let j=0;j<nV;j++){ const a = i*(nV+1) + j, b = a + nV + 1; idx.push(a, b, a+1, b, b+1, a+1); }
    const geo = new THREE.BufferGeometry();
    geo.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    geo.setAttribute('normal', new THREE.Float32BufferAttribute(nrm, 3));
    geo.setIndex(idx);
    return new THREE.Mesh(geo, mat);
  }
  ledGroup.add(rimPatch(-LM_T, LM_T, LM_TH0, LM_TH1, LM_GROW, pianoMat));
  { // rounded black lip around the insert so it reads as a fitted part
    const pts = [], N = 60;
    for(let i=0;i<=N;i++) pts.push(secPoint(rimSection(-LM_T + 2*LM_T*i/N), LM_TH1, LM_GROW));
    for(let j=1;j<=8;j++)  pts.push(secPoint(rimSection(LM_T), LM_TH1 - (LM_TH1 - LM_TH0)*j/8, LM_GROW));
    for(let i=N-1;i>=0;i--) pts.push(secPoint(rimSection(-LM_T + 2*LM_T*i/N), LM_TH0, LM_GROW));
    for(let j=1;j<8;j++)   pts.push(secPoint(rimSection(-LM_T), LM_TH0 + (LM_TH1 - LM_TH0)*j/8, LM_GROW));
    ledGroup.add(new THREE.Mesh(new THREE.TubeGeometry(new THREE.CatmullRomCurve3(pts, true), 400, 0.007, 6, true), pianoMat));
  }
  function onInsert(t, th, lift){   // position + orientation (x along the rim, z out of the surface)
    const sec = rimSection(t), n = secNormal(sec, th);
    return {pos:secPoint(sec, th, LM_GROW).addScaledVector(n, lift),
            quat:new THREE.Quaternion().setFromRotationMatrix(new THREE.Matrix4().makeBasis(sec.tan, n.clone().cross(sec.tan), n)), n};
  }
  const haloTex = canvasTex(128, (g,S)=>{
    const gr = g.createRadialGradient(S/2,S/2,0,S/2,S/2,S/2);
    gr.addColorStop(0,'rgba(255,255,255,1)'); gr.addColorStop(.35,'rgba(255,255,255,.35)'); gr.addColorStop(1,'rgba(255,255,255,0)');
    g.fillStyle = gr; g.fillRect(0,0,S,S);
  });
  const ledGeo = new THREE.BoxGeometry(0.036, 0.022, 0.008), haloGeo = new THREE.PlaneGeometry(0.1, 0.07);
  const barCols = [0x22c55e, 0x22c55e, 0xf0c419, 0xf0c419, 0xe0141f, 0xe0141f];   // outer → centre
  [-1,1].forEach(s=>{
    barCols.forEach((col,i)=>{
      const {pos, quat, n} = onInsert(s*(0.098 - i*0.0105), LM_TH, 0.004);
      const led = new THREE.Mesh(ledGeo, new THREE.MeshBasicMaterial({color:col, toneMapped:false}));
      led.position.copy(pos); led.quaternion.copy(quat);
      const halo = new THREE.Mesh(haloGeo, new THREE.MeshBasicMaterial({color:col, map:haloTex, transparent:true, opacity:.5, depthWrite:false, blending:THREE.AdditiveBlending, toneMapped:false}));
      halo.position.copy(pos).addScaledVector(n, 0.005); halo.quaternion.copy(quat);
      ledGroup.add(led, halo);
    });
    // small end button (chrome ring + black cap) and a tiny indicator dot near the display
    const b = onInsert(s*0.114, LM_TH, 0.0);
    const cap = new THREE.Mesh(new THREE.CylinderGeometry(0.016, 0.016, 0.012, 24), buttonMat);
    cap.position.copy(b.pos); cap.quaternion.copy(b.quat); cap.rotateX(Math.PI/2); ledGroup.add(cap);
    const ring = new THREE.Mesh(new THREE.TorusGeometry(0.017, 0.003, 8, 24), chromeMat);
    ring.position.copy(b.pos).addScaledVector(b.n, 0.004); ring.quaternion.copy(b.quat); ledGroup.add(ring);
    const d = onInsert(s*0.052, 0.55, 0.002);
    const dot = new THREE.Mesh(new THREE.SphereGeometry(0.008, 12, 8), chromeMat);
    dot.position.copy(d.pos); ledGroup.add(dot);
  });
  { // small digital display at 12 o'clock
    const scr = document.createElement('canvas'); scr.width = 512; scr.height = 224;
    const g = scr.getContext('2d');
    g.fillStyle = '#050505'; g.fillRect(0,0,512,224);
    g.strokeStyle = '#d8d8d8'; g.lineWidth = 5;
    g.strokeRect(34,38,64,56); g.beginPath(); g.arc(66,70,16,Math.PI,0); g.stroke();       // gauge icon
    g.strokeRect(34,130,64,56); g.fillStyle = '#d8d8d8'; g.fillRect(48,160,36,14);         // car icon
    g.font = '600 64px "Courier New", monospace'; g.textAlign = 'right'; g.textBaseline = 'middle';
    g.fillText('2717 rpm', 490, 68); g.fillText('0 km/h', 490, 160);
    const tex = new THREE.CanvasTexture(scr); tex.encoding = THREE.sRGBEncoding; tex.anisotropy = maxAniso;
    const {pos, quat} = onInsert(0, LM_TH, 0.003);
    const screen = new THREE.Mesh(new THREE.PlaneGeometry(0.155, 0.068), new THREE.MeshBasicMaterial({map:tex, toneMapped:false}));
    screen.position.copy(pos); screen.quaternion.copy(quat);
    const bezel = new THREE.Mesh(new THREE.BoxGeometry(0.175, 0.086, 0.006), pianoMat);
    bezel.position.copy(pos); bezel.quaternion.copy(quat); bezel.translateZ(-0.0035);
    ledGroup.add(bezel, screen);
  }
  wheelGroup.add(ledGroup);
  ledGroup.visible = false;

  // stitches (rim + airbag), built last so every run is collected
  const stitchGeo = new THREE.CylinderGeometry(0.0055, 0.0055, 1, 6);
  const stitches = new THREE.InstancedMesh(stitchGeo, stitchMat, stitchSegs.length);
  {
    const m4 = new THREE.Matrix4(), q = new THREE.Quaternion(), yAxis = new V3(0,1,0);
    stitchSegs.forEach(([a,b],i)=>{
      const d = b.clone().sub(a), l = d.length();
      q.setFromUnitVectors(yAxis, d.normalize());
      m4.compose(a.clone().add(b).multiplyScalar(.5), q, new V3(1, l, 1));
      stitches.setMatrixAt(i, m4);
    });
  }
  wheelGroup.add(stitches);

  // ---- backdrop glow ----
  const glowTex = canvasTex(256, (g)=>{
    const gr = g.createRadialGradient(128,128,8,128,128,118);   // fades to 0 well inside the canvas edge
    gr.addColorStop(0,'rgba(224,20,31,0.12)'); gr.addColorStop(.45,'rgba(255,255,255,0.025)'); gr.addColorStop(1,'rgba(0,0,0,0)');
    g.fillStyle = gr; g.fillRect(0,0,256,256);
  }, true);
  const glow = new THREE.Mesh(new THREE.PlaneGeometry(6,6), new THREE.MeshBasicMaterial({map:glowTex, transparent:true, depthWrite:false}));
  glow.position.z = -2.4; scene.add(glow);

  // soft shadows between parts; unlit overlays excluded
  wheelGroup.traverse(o=>{
    if(o.isMesh && !(o.material instanceof THREE.MeshBasicMaterial)){ o.castShadow = true; o.receiveShadow = true; }
  });

  // ---- state application (same API as before: the UI wiring below calls these) ----
  function setTransmission(auto){ paddles.forEach(p => p.visible = auto); }
  function setLed(on){ ledGroup.visible = on; marker.visible = !on; }   // the display takes the 12 o'clock spot
  function setStitch(hex){ stitchMat.color.copy(lin(hex)); markerMat.color.copy(lin(hex)); }   // marker matches the stitching, as on the reference
  function setCarbon(hex){
    const tint = hex.toLowerCase() === '#141414' ? null : hex;
    const [fm, fr] = forgedTextures(tint);   // woven carbon exists in black only → only the forged is tinted
    [[forgedMat,'map',fm],[forgedMat,'roughnessMap',fr]].forEach(([m,k,t])=>{ m[k].dispose(); m[k] = t; });
    forgedMat.needsUpdate = true;
  }
  function setCarbonType(tresse){ rimForged.forEach(m => m.visible = !tresse); rimTwill.forEach(m => m.visible = tresse); }
  function setFinish(brillant){
    forgedMat.roughness = brillant ? 1 : 1.6;      // scales the per-flake roughness map
    twillMat.roughness = brillant ? .28 : .6;
    carbonMats.forEach(m=>{ m.clearcoat = brillant ? 1 : .25; m.clearcoatRoughness = brillant ? .03 : .6; });
  }

  // ---- camera: starts perfectly frontal; drag to orbit, wheel to zoom, double-click to reset ----
  const CY = 0.02, HOME = {rotY:0, rotX:0, dist:11.4};
  let rotY = HOME.rotY, rotX = HOME.rotX, dist = HOME.dist, dragging = false, lastX = 0, lastY = 0;
  function updateCamera(){
    camera.position.set(Math.sin(rotY)*dist*Math.cos(rotX), CY + Math.sin(rotX)*dist, Math.cos(rotY)*dist*Math.cos(rotX));
    camera.lookAt(0, CY, 0);
  }
  updateCamera();
  canvas.style.cursor = 'grab';
  canvas.addEventListener('pointerdown', e=>{ dragging = true; lastX = e.clientX; lastY = e.clientY; canvas.style.cursor = 'grabbing'; canvas.setPointerCapture(e.pointerId); });
  window.addEventListener('pointermove', e=>{
    if(!dragging) return;
    rotY += (e.clientX - lastX)*0.007;
    rotX = Math.max(-0.6, Math.min(0.7, rotX + (e.clientY - lastY)*0.006));
    lastX = e.clientX; lastY = e.clientY; updateCamera();
  });
  window.addEventListener('pointerup', ()=>{ dragging = false; canvas.style.cursor = 'grab'; });
  canvas.addEventListener('wheel', e=>{ e.preventDefault(); dist = Math.max(6, Math.min(16, dist + e.deltaY*0.006)); updateCamera(); }, {passive:false});
  canvas.addEventListener('dblclick', ()=>{ ({rotY, rotX, dist} = HOME); updateCamera(); });

  function resize(){ const w = container.clientWidth; renderer.setSize(w, w, false); camera.aspect = 1; camera.updateProjectionMatrix(); }
  window.addEventListener('resize', resize); resize();

  // only render while the configurator is on screen
  let visible = true;
  new IntersectionObserver(es=>{ visible = es[0].isIntersecting; }).observe(container);
  (function animate(){
    requestAnimationFrame(animate);
    if(visible) renderer.render(scene, camera);
  })();

  // ---- UI wiring ----
  let state = {trans:'Automatique', led:'Sans LED', stitchHex:'#e0141f', stitch:'Rouge', carbonHex:'#141414', carbon:'Noir', finish:'Brillant', ctype:'Forgé'};
  function updateSummary(){
    document.getElementById('rc-trans').textContent = state.trans;
    document.getElementById('rc-led').textContent = state.led;
    document.getElementById('rc-stitch').textContent = state.stitch;
    document.getElementById('rc-carbon').textContent = state.carbon;
    document.getElementById('rc-finish').textContent = state.finish;
    document.getElementById('rc-ctype').textContent = state.ctype;
    const brand = document.getElementById('cfg-brand').value, model = document.getElementById('cfg-model').value.trim();
    document.getElementById('rc-vehicle').textContent = brand ? (brand + (model ? ' ' + model : '')) : '—';
    document.getElementById('rc-stitch-dot').style.setProperty('--c', state.stitchHex);
    document.getElementById('rc-carbon-dot').style.setProperty('--c', state.carbonHex);
  }
  function groupClick(selector, onPick){
    document.querySelectorAll(selector).forEach(btn=>{
      btn.addEventListener('click', ()=>{
        btn.parentElement.querySelectorAll(selector).forEach(b=>b.classList.remove('active'));
        btn.classList.add('active'); onPick(btn); updateSummary();
      });
    });
  }
  groupClick('[data-trans]', b=>{ state.trans=b.dataset.trans; setTransmission(state.trans==='Automatique'); });
  groupClick('[data-led]', b=>{ state.led=b.dataset.led; setLed(state.led==='Avec LED'); });
  groupClick('[data-color]', b=>{ state.stitch=b.dataset.name; state.stitchHex=b.dataset.color; setStitch(state.stitchHex); });
  groupClick('[data-tint]', b=>{ state.carbon=b.dataset.cname; state.carbonHex = b.dataset.tint==='transparent' ? '#141414' : b.dataset.tint; setCarbon(state.carbonHex); });
  groupClick('[data-finish]', b=>{ state.finish=b.dataset.finish; setFinish(state.finish==='Brillant'); });
  const tintBtns = document.querySelectorAll('[data-tint]');
  groupClick('[data-ctype]', b=>{
    state.ctype = b.dataset.ctype;
    const tresse = state.ctype === 'Tressé';
    setCarbonType(tresse);
    // woven carbon is only offered in black: switch to black and lock the other colours
    if(tresse && state.carbon !== 'Noir') document.querySelector('[data-tint="transparent"]').click();
    tintBtns.forEach(t=>{ const lock = tresse && t.dataset.tint !== 'transparent'; t.disabled = lock; t.title = lock ? 'Carbone tressé : noir uniquement' : ''; });
    document.getElementById('tint-note').hidden = !tresse;
  });
  const brandSel = document.getElementById('cfg-brand');
  ['change','input'].forEach(ev=>{
    brandSel.addEventListener(ev, ()=>{
      brandSel.classList.remove('invalid'); document.getElementById('cfg-vehicle-err').hidden = true;
      document.getElementById('cfg-other-note').hidden = brandSel.value !== 'Autre marque';
      updateSummary();
    });
    document.getElementById('cfg-model').addEventListener(ev, updateSummary);
  });

  setTransmission(true); setLed(false); updateSummary();

  const cfgToDevis = document.getElementById('cfg-to-devis');
  if(cfgToDevis){
    cfgToDevis.addEventListener('click', e=>{
      const model = document.getElementById('cfg-model').value.trim();
      if(!brandSel.value){   // the brand is needed to quote: stay on the configurator and point at the field
        e.preventDefault();
        brandSel.classList.add('invalid');
        document.getElementById('cfg-vehicle-err').hidden = false;
        brandSel.focus();
        return;
      }
      const vehicle = document.getElementById('df-vehicle');
      if(vehicle) vehicle.value = brandSel.value + (model ? ' ' + model : '');
      const msg = document.getElementById('df-msg');
      if(msg) msg.value = `Configuration souhaitée : ${state.trans} · ${state.led} · Carbone ${state.ctype.toLowerCase()} ${state.carbon} ${state.finish.toLowerCase()} · Surpiqûre ${state.stitch}`;
      // structured choices for the request filed in Shopify (→ "Composition personnalisée")
      document.getElementById('devis-form').dataset.config = JSON.stringify({'Transmission':state.trans, 'Rétroéclairage':state.led, 'Surpiqûre':state.stitch, 'Couleur du carbone':state.carbon, 'Finition':state.finish, 'Type de carbone':state.ctype});
    });
  }
})();

// ---- form delivery ----------------------------------------------------------------------------
// Configurator quotes, custom searches and newsletter sign-ups are sent to the STRPERF relay
// (strperf-demandes/worker.js), which files them in the Shopify admin — seller-only:
//   · compositions & searches → Orders › Drafts, tagged "demande-personnalisee"
//   · newsletter              → Customers, subscribed to email marketing, tagged "newsletter"
// Until the relay's URL is filled in below:
//   · on the Shopify store, the forms post natively (Shopify contact form / customer sign-up);
//   · on a local copy of the page, the visitor's mail app opens with the request pre-filled.
// If the relay can't be reached, the mail-app fallback is used, so no request is ever lost.
const REQUESTS_ENDPOINT = 'https://strperf-demandes.strperfcontact.workers.dev';   // STRPERF relay (Cloudflare)
const CONTACT_EMAIL = 'strperfcontact@gmail.com';
const ON_SHOPIFY = !!window.Shopify;   // defined by Shopify on the live store
const NATIVE_FORMS = !REQUESTS_ENDPOINT && ON_SHOPIFY;
async function sendRequest(payload){
  if(!REQUESTS_ENDPOINT) throw new Error('relay not configured');
  const res = await fetch(REQUESTS_ENDPOINT, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)});
  const data = await res.json().catch(()=>({}));
  if(!res.ok || !data.ok) throw new Error(data.error || 'HTTP ' + res.status);
  return data;
}
function mailtoFallback(subject, lines){
  window.location.href = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(lines.join('\n'))}`;
}
function formStatus(form, kind, text){
  if(!form._status){
    form._status = document.createElement('p');
    form._status.className = 'form-status';
    form._status.setAttribute('role', 'status');
    form.insertAdjacentElement('afterend', form._status);
  }
  form._status.dataset.kind = kind; form._status.textContent = text;
}
async function deliver(form, payload, subject, lines, okText){
  if(payload._honey) return false;   // hidden field filled → a bot
  const btn = form.querySelector('button[type="submit"]'), label = btn.textContent;
  btn.disabled = true; btn.textContent = 'Envoi…'; formStatus(form, 'pending', '');
  try{
    const res = await sendRequest(payload);
    form.reset(); formStatus(form, 'ok', okText + (res.reference ? ` (référence ${res.reference})` : ''));
    return true;
  }catch(err){
    formStatus(form, 'error', "Votre messagerie s'ouvre avec la demande pré-remplie : il suffit de l'envoyer pour qu'elle nous parvienne.");
    mailtoFallback(subject, lines);
    return false;
  }finally{
    btn.disabled = false; btn.textContent = label;
  }
}
const field = id => document.getElementById(id).value.trim();

// configurator quote or custom search ("Trouvez votre volant")
const devisForm = document.getElementById('devis-form');
if(devisForm){
  devisForm.addEventListener('submit', async e=>{
    let configuration = null;   // set by the configurator's quote button
    try{ configuration = devisForm.dataset.config ? JSON.parse(devisForm.dataset.config) : null; }catch(err){ configuration = null; }
    const kind = configuration ? 'composition' : 'recherche';
    const label = configuration ? 'Composition personnalisée' : 'Recherche personnalisée';
    if(NATIVE_FORMS){   // let Shopify's own contact form submit, with the request type and configuration attached
      document.getElementById('df-kind').value = label;
      document.getElementById('df-config').value = configuration ? Object.entries(configuration).map(([k,v])=>`${k} : ${v}`).join(' · ') : '—';
      return;
    }
    e.preventDefault();
    const payload = {kind, name:field('df-name'), email:field('df-email'), vehicle:field('df-vehicle'), message:field('df-msg'),
                     configuration, _honey:devisForm.querySelector('[name="_honey"]').value};
    const lines = [`Type de demande : ${label}`, `Nom : ${payload.name}`, `Email : ${payload.email}`, `Véhicule : ${payload.vehicle}`]
      .concat(configuration ? Object.entries(configuration).map(([k,v])=>`${k} : ${v}`) : [], ['', payload.message]);
    const sent = await deliver(devisForm, payload, `${label} — ${payload.vehicle}`, lines,
      'Merci ! Votre demande est bien enregistrée : nous revenons vers vous par email avec votre devis.');
    if(sent) delete devisForm.dataset.config;
  });
}

// newsletter sign-up (-10 % on the first order)
const nlForm = document.getElementById('nl-form');
if(nlForm){
  nlForm.addEventListener('submit', e=>{
    if(ON_SHOPIFY) return;   // always Shopify's own customer sign-up: tagged "newsletter", triggers the welcome e-mail
    e.preventDefault();
    const email = field('nl-email');
    deliver(nlForm, {kind:'newsletter', email, _honey:nlForm.querySelector('[name="_honey"]').value},
      'Inscription newsletter — ' + email, ['Inscription newsletter (-10 % sur la première commande)', 'Email : ' + email],
      'Merci ! Inscription enregistrée : votre code -10 % vous sera envoyé par email.');
  });
}

// brand pages data + router
const BANNERS = window.STRPERF_BANNERS || {};   // asset URLs, set by sections/strperf-home.liquid
const BRANDS = {
  bmw:{name:'BMW', eyebrow:'BMW — COMPATIBILITÉ', desc:"Volants carbone développés pour la gamme BMW Série 1 à 4 ainsi que M2, M3 et M4. Compatibilité vérifiée avec l'airbag et les commandes multifonctions d'origine.",
    compat:['Série 1 (F20/F40)','Série 2 (F22/F44)','Série 3 (F30/G20)','Série 4 (F32/G22)','M2 / M3 / M4 (F8x / G8x)'],
    products:[{n:'Volant Carbone Track', tag:'M3/M4', p:'650€', c:'bmw'},{n:'Volant Carbone Alcantara', tag:'Série 1-4', p:'480€', c:'bmw'}]},
  audi:{name:'Audi', eyebrow:'AUDI — COMPATIBILITÉ', desc:"Volants carbone pour la gamme Audi A3, S3, RS3 et RS4, inspirés des volants de rallye. Compatibles airbag et MMI d'origine.",
    compat:['A3 / S3 (8Y/8V)','RS3 (8Y/8V)','A4 / RS4 (B9)','Q2 / Q3'],
    products:[{n:'Volant Carbone Rallye', tag:'RS3/RS4', p:'690€', c:'audi'},{n:'Volant Carbone Sport', tag:'A3/S3', p:'450€', c:'audi'}]},
  porsche:{name:'Porsche', eyebrow:'PORSCHE — COMPATIBILITÉ', desc:"Volants carbone tressé pour Porsche 911, Cayman et Boxster, inspirés des volants GT de compétition. Compatibles PCM et commandes multifonctions.",
    compat:['911 (992/991)','Cayman / Boxster (718/981)','Panamera','Macan'],
    products:[{n:'Volant Carbone GT', tag:'911/Cayman', p:'890€', c:'porsche'},{n:'Volant Carbone Alcantara', tag:'Boxster/Cayman', p:'730€', c:'porsche'}]},
  mercedes:{name:'Mercedes-AMG', eyebrow:'MERCEDES-AMG — COMPATIBILITÉ', desc:"Volants carbone Performance pour Mercedes Classe A, Classe C et gamme AMG. Compatibles commandes tactiles et airbag d'origine.",
    compat:['Classe A (W177)','Classe C (W206)','AMG GT','CLA / GLA'],
    products:[{n:'Volant Carbone Performance', tag:'Classe A/C', p:'620€', c:'mercedes'},{n:'Volant Carbone Flat-Bottom', tag:'AMG GT', p:'780€', c:'mercedes'}]},
  vw:{name:'Volkswagen', eyebrow:'VOLKSWAGEN — COMPATIBILITÉ', desc:"Volants carbone pour Golf GTI, Golf R (Mk7/Mk8) et Polo GTI. Compatibles régulateur, commandes multifonctions et airbag d'origine.",
    compat:['Golf 7 / GTI / R','Golf 8 / GTI / R','Polo GTI (AW)','T-Roc'],
    products:[{n:'Volant Carbone GTI/R', tag:'Golf 7/8', p:'490€', c:'vw'},{n:'Volant Carbone Motorsport', tag:'Polo GTI', p:'420€', c:'vw'}]},
  cupra:{name:'Seat / Cupra', eyebrow:'SEAT / CUPRA — COMPATIBILITÉ', desc:"Volants carbone racing pour Seat Leon Cupra et Cupra Formentor/Leon, alliant look sportif et confort au quotidien.",
    compat:['Leon Cupra (Mk3/Mk4)','Cupra Formentor','Cupra Leon'],
    products:[{n:'Volant Carbone Racing', tag:'Leon/Formentor', p:'480€', c:'cupra'}]}
};
const INSTALL_STEPS = [
  {t:'Vérification de compatibilité', d:"On confirme la génération exacte de votre véhicule et la compatibilité avec votre airbag et vos commandes d'origine."},
  {t:"Dépose du volant d'origine", d:'Batterie débranchée, airbag déposé selon la procédure constructeur — étape à confier à un professionnel.'},
  {t:'Montage du nouveau volant', d:"Transfert des connecteurs et de l'airbag d'origine sur le nouveau volant, fixation au moyeu d'origine."},
  {t:'Contrôle final', d:"Vérification des commandes, de l'airbag et des témoins tableau de bord avant remise du véhicule."}
];
function shopUrl(collection){ return '/collections/' + (collection==='mercedes'?'mercedes-amg':collection==='cupra'?'seat-cupra':collection); }
function renderBrand(key){
  const b = BRANDS[key];
  if(!b) return false;
  document.querySelector('.bp-head').style.backgroundImage = `linear-gradient(180deg, rgba(10,10,10,.3), rgba(10,10,10,.78) 60%, var(--bg)), url(${BANNERS[key]})`;
  document.getElementById('bp-eyebrow').textContent = b.eyebrow;
  document.getElementById('bp-title').textContent = b.name;
  document.getElementById('bp-desc').textContent = b.desc;
  document.getElementById('bp-compat-list').innerHTML = b.compat.map(c=>`<span>${c}</span>`).join('');
  document.getElementById('bp-products-list').innerHTML = b.products.map(p=>`
    <div class="p-card"><div class="p-visual"><div class="ring"><span class="init2">${b.name}</span></div></div>
    <div class="p-body"><div class="tag">${b.name.toUpperCase()} · ${p.tag}</div><h4>${p.n}</h4>
    <div class="p-foot"><span class="price">${p.p}</span><a href="${shopUrl(p.c)}">Découvrir</a></div></div></div>`).join('');
  document.getElementById('bp-steps').innerHTML = INSTALL_STEPS.map((s,i)=>`
    <div class="bp-step"><span class="si">0${i+1}</span><div><h4>${s.t}</h4><p>${s.d}</p></div></div>`).join('');
  document.title = b.name + ' — STRPERF';
  return true;
}
function router(){
  const key = location.hash.replace('#','');
  const home = document.getElementById('home');
  const bp = document.getElementById('brand-page');
  if(key && renderBrand(key)){
    home.hidden = true; bp.hidden = false;
    window.scrollTo(0,0);
  } else {
    const wasHidden = home.hidden;
    home.hidden = false; bp.hidden = true;
    document.title = 'STRPERF — Volants Carbone Sur Mesure';
    // coming back from a brand page: the browser couldn't scroll to a hidden section, do it now
    const target = key && document.getElementById(key);
    if(wasHidden) target ? target.scrollIntoView() : window.scrollTo(0,0);
  }
}
document.querySelectorAll('[data-brand]').forEach(a=>{
  a.addEventListener('click', e=>{ e.preventDefault(); location.hash = a.dataset.brand; });
});
document.getElementById('bp-back').addEventListener('click', e=>{ e.preventDefault(); location.hash=''; });
window.addEventListener('hashchange', router);
router();

// material samples in "Savoir-faire": procedural swatches redrawn to fit each card
(function(){
  const cans = document.querySelectorAll('canvas.mat-swatch');
  if(!cans.length) return;
  const rnd = (a,b) => a + Math.random()*(b - a);
  const painters = {
    carbon(g, W, H){   // 2x2 twill with a clear-coat reflection
      g.fillStyle = '#050505'; g.fillRect(0,0,W,H);
      const cs = Math.max(6, Math.round(W/46));
      for(let j=0; j*cs < H + cs; j++) for(let i=0; i*cs < W + cs; i++){
        const v = ((i - j + 400) % 4) < 2, x = i*cs, y = j*cs;
        const gr = v ? g.createLinearGradient(x,0,x+cs,0) : g.createLinearGradient(0,y,0,y+cs);
        gr.addColorStop(0,'#0d0d0d'); gr.addColorStop(.5, v ? '#6a6a6a' : '#303030'); gr.addColorStop(1,'#0d0d0d');
        g.fillStyle = gr; g.fillRect(x+.5, y+.5, cs-1, cs-1);
      }
      const s = g.createLinearGradient(0,0,W,H);
      s.addColorStop(0,'rgba(255,255,255,0)'); s.addColorStop(.4,'rgba(255,255,255,0)');
      s.addColorStop(.5,'rgba(255,255,255,.2)'); s.addColorStop(.6,'rgba(255,255,255,0)');
      g.fillStyle = s; g.fillRect(0,0,W,H);
    },
    alcantara(g, W, H){   // soft nap patches + fine fibre noise, very matte
      g.fillStyle = '#2e2e2e'; g.fillRect(0,0,W,H);
      for(let i=0;i<140;i++){
        const x = rnd(0,W), y = rnd(0,H), r = rnd(20,90), light = Math.random() > .5;
        const gr = g.createRadialGradient(x,y,0,x,y,r);
        gr.addColorStop(0, light ? 'rgba(255,255,255,.04)' : 'rgba(0,0,0,.09)'); gr.addColorStop(1,'rgba(0,0,0,0)');
        g.fillStyle = gr; g.fillRect(x-r, y-r, 2*r, 2*r);
      }
      const img = g.getImageData(0,0,W,H), d = img.data;
      for(let i=0;i<d.length;i+=4){ const n = (Math.random() - .5)*20; d[i] += n; d[i+1] += n; d[i+2] += n; }
      g.putImageData(img,0,0);
      const s = g.createLinearGradient(0,0,W,0);
      s.addColorStop(0,'rgba(255,255,255,.05)'); s.addColorStop(1,'rgba(0,0,0,.14)');
      g.fillStyle = s; g.fillRect(0,0,W,H);
    },
    nappa(g, W, H){   // pebble grain, soft sheen and a row of contrast baseball stitching
      g.fillStyle = '#151515'; g.fillRect(0,0,W,H);
      for(let i=0;i<W*H/26;i++){
        const r = rnd(1.5,4);
        g.fillStyle = Math.random() > .5 ? 'rgba(255,255,255,.045)' : 'rgba(0,0,0,.35)';
        g.beginPath(); g.ellipse(rnd(0,W), rnd(0,H), r, r*rnd(.6,1), rnd(0,3), 0, Math.PI*2); g.fill();
      }
      const hl = g.createRadialGradient(W*.3,H*.2,0,W*.3,H*.2,W*.7);
      hl.addColorStop(0,'rgba(255,255,255,.08)'); hl.addColorStop(1,'rgba(0,0,0,0)');
      g.fillStyle = hl; g.fillRect(0,0,W,H);
      const y0 = H*.55, step = Math.max(12, W/34);
      g.strokeStyle = 'rgba(0,0,0,.8)'; g.lineWidth = 3; g.beginPath(); g.moveTo(0,y0); g.lineTo(W,y0); g.stroke();
      g.strokeStyle = '#e0141f'; g.lineWidth = Math.max(2, W/300); g.lineCap = 'round';
      for(let x=step/2; x<W; x+=step){
        g.beginPath(); g.moveTo(x, y0 - step*.45); g.lineTo(x + step*.5, y0); g.moveTo(x, y0 + step*.45); g.lineTo(x + step*.5, y0); g.stroke();
      }
    }
  };
  function paint(){
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    cans.forEach(c=>{
      const W = Math.round(c.clientWidth*dpr), H = Math.round(c.clientHeight*dpr);
      if(!W || !H) return;
      c.width = W; c.height = H;
      // the suede swatch reads its pixels back (noise pass): declare it so the browser doesn't warn
      painters[c.dataset.mat](c.getContext('2d', {willReadFrequently: c.dataset.mat === 'alcantara'}), W, H);
    });
  }
  paint();
  let t; window.addEventListener('resize', ()=>{ clearTimeout(t); t = setTimeout(paint, 200); });
})();

// in-page links (hero buttons, nav, "Trouvez votre volant"…): always land on the section — even from
// a brand page — with the sticky header accounted for by scroll-padding-top
document.addEventListener('click', e=>{
  if(e.defaultPrevented) return;
  const a = e.target.closest('a[href^="#"]');
  if(!a) return;
  const id = a.getAttribute('href').slice(1), target = id && document.getElementById(id), home = document.getElementById('home');
  if(!target || document.getElementById('brand-page').contains(target)) return;
  e.preventDefault();
  if(home.hidden && home.contains(target)){
    home.hidden = false; document.getElementById('brand-page').hidden = true;
    document.title = 'STRPERF — Volants Carbone Sur Mesure';
  }
  target.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
  // update the address bar without re-running the router. Chrome refuses pushState on pages opened
  // from disk (file://, origin "null") — best-effort only, the scroll above has already happened
  try{ history.pushState(null, '', '#' + id); }catch(err){}
  if(id === 'newsletter'){ target.classList.remove('flash'); void target.offsetWidth; target.classList.add('flash'); }   // draw the eye to the sign-up
});

// "Autre marque" card: preselect it in the configurator's vehicle step
document.getElementById('brand-other').addEventListener('click', ()=>{
  const sel = document.getElementById('cfg-brand');
  sel.value = 'Autre marque'; sel.dispatchEvent(new Event('change'));
});
